import { jsx as A } from "react/jsx-runtime";
import { forwardRef as O, useRef as u, useState as m, useEffect as g, useCallback as k, useImperativeHandle as Q } from "react";
import { postToIframe as X, isBridgeMessage as Z } from "./protocol.js";
import { DEFAULT_THEME as S } from "../utils/theme.js";
/* empty css                */
const P = "/concierge-widgets", ee = 10, ne = "1000px", oe = O(function({
  widget: E,
  version: D = "v1",
  cdnBase: L = P,
  toolInput: c = {},
  toolOutput: a = null,
  dataParts: o = [],
  partState: l = "",
  savedState: d = null,
  onSaveState: b,
  onAction: _,
  theme: $ = S,
  auth: F = { token: null, status: "unknown" },
  apiBaseUrl: C = "",
  editMode: W = !1,
  themeConfig: w = null,
  ctx: z = { brandAppConfig: null, domainConfig: null },
  urlSearchParams: B = "",
  onRegisterEditFields: R,
  className: G
}, J) {
  const y = u(null), [t, I] = m(!1), [U, j] = m(null), [i, H] = m(!1), [V, Y] = m(!1), [p, M] = m(!1), T = u(null), f = u(!1), h = u(""), v = u(d);
  v.current = d, g(() => {
    const n = T.current;
    if (!n) return;
    const s = new IntersectionObserver(
      ([e]) => {
        e.isIntersecting && !i ? H(!0) : !e.isIntersecting && i && (v.current && b?.(v.current), H(!1), I(!1), f.current = !1, h.current = "");
      },
      { rootMargin: ne }
    );
    return s.observe(n), () => s.disconnect();
  }, [i, b]), g(() => {
    if (!i) return;
    const n = (s) => {
      if (s.source !== y.current?.contentWindow || !Z(s.data)) return;
      const e = s.data;
      switch (e.type) {
        case "bc:ready":
          I(!0);
          break;
        case "bc:resize":
          j(e.height);
          break;
        case "bc:action":
          _?.({ action: e.action, payload: e.payload });
          break;
        case "bc:save_state":
          b?.(e.state);
          break;
        case "bc:register_edit_fields":
          R?.(
            e.widgetId,
            e.editFields,
            e.defaultState,
            e.currentState
          );
          break;
        case "bc:command":
          e.command === "hide" && Y(!0), e.command === "collapse" && M(!0), e.command === "expand" && M(!1);
          break;
      }
    };
    return window.addEventListener("message", n), () => window.removeEventListener("message", n);
  }, [i, _, b, R]);
  const r = k(
    (n) => {
      y.current && X(y.current, n);
    },
    []
  );
  g(() => {
    if (!t || f.current) return;
    f.current = !0, r({
      type: "bc:init",
      env: "native",
      apiBaseUrl: C,
      theme: $,
      auth: F,
      savedState: d,
      themeConfig: w,
      editMode: W,
      ctx: z,
      urlSearchParams: B
    }), r({ type: "bc:data", toolInput: c, toolOutput: a, dataParts: o, partState: l, savedState: d }), h.current = JSON.stringify({ toolInput: c, toolOutput: a, dataParts: o, partState: l });
  }, [t]), g(() => {
    if (!t || !f.current) return;
    const n = JSON.stringify({ toolInput: c, toolOutput: a, dataParts: o, partState: l });
    n !== h.current && (h.current = n, r({ type: "bc:data", toolInput: c, toolOutput: a, dataParts: o, partState: l, savedState: d }));
  }, [t, c, a, o, l]), g(() => {
    !t || !f.current || !w || r({ type: "bc:theme_config", themeConfig: w });
  }, [t, w]);
  const x = k(
    (n, s, e) => {
      r({ type: "bc:edit_change", key: n, value: s, state: e });
    },
    [r]
  ), N = k(
    (n) => {
      r({ type: "bc:edit_saved", state: n });
    },
    [r]
  );
  Q(J, () => ({ sendEditChange: x, sendEditSaved: N }), [x, N]);
  const q = `${L}/${D}/${E}/index.html`;
  if (V) return null;
  const K = p ? 0 : U ?? ee;
  return /* @__PURE__ */ A(
    "div",
    {
      ref: T,
      className: `bc-widget-frame ${G ?? ""}`,
      style: {
        overflow: p ? "hidden" : void 0,
        transition: p ? "height 0.3s ease" : void 0
      },
      children: i && /* @__PURE__ */ A(
        "iframe",
        {
          ref: y,
          src: q,
          loading: "lazy",
          title: `${E} widget`,
          style: {
            width: "100%",
            height: K,
            border: "none",
            display: "block"
          },
          sandbox: "allow-scripts allow-same-origin allow-forms allow-popups",
          allow: "geolocation"
        }
      )
    }
  );
});
export {
  oe as WidgetFrame
};
